import type { ContactsListApiResponse, ErrorResponse } from "./types";

export const isErrorResponse = (
  value: ContactsListApiResponse | null | undefined,
): value is ErrorResponse => {
  return !!value && "error" in value;
};
